import {
  getSubComponent,
  getSubComponentStyles,
} from '../../utils/react.utils';

interface Props {
  children?: any;
  className?: string;
  backgroundImage?: string;
  contentStyles?: string;
  onClick?: Function;
}

type SubComponentNames = 'Header' | 'Body' | 'Footer';
function Card(props: Props) {
  const { children, className, backgroundImage, onClick } = props;

  const Header = getSubComponent<SubComponentNames>(children, 'Header');
  const Body = getSubComponent<SubComponentNames>(children, 'Body');
  const Footer = getSubComponent<SubComponentNames>(children, 'Footer');

  const headerClasses = getSubComponentStyles(Header);
  const bodyClasses = getSubComponentStyles(Body);
  const footerClasses = getSubComponentStyles(Footer);

  const bgImageStyles = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    overflow: 'hidden',
  };

  return (
    <div
      className={`${className} ${onClick ? 'cursor-pointer' : ''}`}
      style={backgroundImage ? bgImageStyles : {}}
      onClick={() => onClick && onClick()}
    >
      <div className={`${headerClasses}`}>{Header}</div>
      <div className={`w-full ${bodyClasses}`}>{Body}</div>
      <div className={`w-full ${footerClasses}`}>{Footer}</div>
    </div>
  );
}

interface ChildrenProps {
  children?: any;
  className?: string;
}

const Header = (props: ChildrenProps) => props.children;
const Body = (props: ChildrenProps) => props.children;
const Footer = (props: ChildrenProps) => props.children;

Header.displayName = 'Header';
Body.displayName = 'Body';
Footer.displayName = 'Footer';

Card.Header = Header;
Card.Body = Body;
Card.Footer = Footer;

export default Card;
